import g from './utils/globalVariables.es6';
import throttle from './utils/throttle.es6';

const OPEN_NAV_SELECTOR = '.js-nav-open';
const CLOSE_NAV_SELECTOR = '.js-nav-close';
const NAV_OPEN_CLASS = 'is-nav-open';
const HIDE_RIBBONS_CLASS = 'has-hidden-ribbons';
const BIG_HEADER_CLASS = 'has-hidden-ribbons';

const STICKY_START_BIG_POSITION = 100;
const SCROLL_THROTTLE_TIME = 100;

let stickyStartPosition = 25;

const init = () => {
  if (g.$body.hasClass(BIG_HEADER_CLASS)) {
    stickyStartPosition = STICKY_START_BIG_POSITION;
  }

  g.$document
    .off('.toggleNavigation')
    .on('click.toggleNavigation', OPEN_NAV_SELECTOR, openNav)
    .on('click.toggleNavigation', CLOSE_NAV_SELECTOR, closeNav);

  g.$window
    .off('scroll.navScroll')
    .on('scroll.navScroll', pageScroll)
    .trigger('scroll.navScroll');
};

const openNav = () => {
  g.$body.addClass(NAV_OPEN_CLASS);
};

const closeNav = () => {
  g.$body.removeClass(NAV_OPEN_CLASS);
};

const pageScroll = throttle(() => {
  if (g.$document.scrollTop() > stickyStartPosition) {
    hideRibbons();
  } else {
    showRibbons();
  }
}, SCROLL_THROTTLE_TIME);

const showRibbons = () => {
  g.$body.removeClass(HIDE_RIBBONS_CLASS);
};

const hideRibbons = () => {
  g.$body.addClass(HIDE_RIBBONS_CLASS);
};

export default init;
